import React from 'react';
type PolicySectionProps = {
  title: string;
  children: React.ReactNode;
};
export function PolicySection({
  title,
  children
}: PolicySectionProps) {
  return <section className="mb-10" data-id="element-13">
      <h2 className="font-serif-display text-2xl sm:text-3xl text-[#0f3f4a] mb-4 tracking-tight" data-id="element-14">
        {title}
      </h2>
      <div className="space-y-4 text-[15px] sm:text-base leading-relaxed text-[#0f3f4a]/85" data-id="element-15">
        {children}
      </div>
    </section>;
}